import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  ProductionModule,
  RawMaterialsModule,
  DemoButton,
  SuppliersModule,
  MarketingModule,
  DigitalCatalogModule,
  QuoteManagementModule,
  SalesOrderModule,
  ProjectsModule,
} from "./CommonModules";

import CartContext from "./CartContext";
import { ECommerceB2CRetail } from "./ECommerceB2cRetail";

export class SolutionManufacturing extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    } else {
      const selected = prods.find((p) => p.productType === ProductType.ERP);
      SetSelectedProduct(selected);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }

    return (
      <>
        {/* Hero Section */}
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row gx-5">
              <div className="col-12 border-start border-5 border-primary ps-3 mb-4">
                <h6 className="text-primary text-uppercase">
                  End-to-End Solution
                </h6>
                <h2 className="display-6 fw-bold">
                  Modern Solution for Manufacturers (ERP)
                </h2>
              </div>
              <div className="mb-4">
                A comprehensive ERP solution designed for manufacturers,
                covering procurement, production, sales, inventory, and
                delivery. It includes POS, ecommerce, CRM, payment gateway
                integration, and marketing tools. The system supports end-to-end
                automation with dashboards, analytics, and third-party delivery
                integration.
              </div>
              <DemoButton></DemoButton>
              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "ManufacturingErpVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <a href="images/supplyChain/overview.png" target="_blank">
                <img
                  class="w-100 rounded"
                  src="images/supplyChain/ErpSolutionOverview.png"
                  style={{ objectFit: "contain" }}
                />
              </a>

              {/* <div className="col-lg-6 mb-4">
                <video
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source src="/videos/pos1.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div> */}

              <div>
                <h6 class="text-primary text-uppercase">Solution</h6>
                <h4 class="display-6  mb-0">
                  Business Workflow - Our Solution
                </h4>
                <a
                  href="images/supplyChain/supplychainworkflow.png"
                  target="_blank"
                >
                  <img
                    class="w-100 rounded"
                    src="images/supplyChain/supplychainworkflow.png"
                    style={{ objectFit: "contain" }}
                  />
                </a>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="bg-light p-4 rounded shadow-sm">
                {/* POS Feature Sections */}
                <FeatureSection
                  title="Features & Benefits"
                  items={[
                    "Purchase/Procurement Management",
                    "Suppliers Management",
                    "Inventory & Stocks Management",
                    "Production Management",
                    "Warehouse Management",
                    "Lead Management",
                    "Quote Management",
                    "Point-Of-Sale (POS)",
                    "ECommerce B2C website",
                    "ECommerce B2B website",
                    "Orders Management",
                    "Packaging Management",
                    "Delivery Management",
                    "return and refund management",
                    "Customer Relationship Management (CRM)",
                    "Coupons Management",
                    "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateway Integration",
                    "HR & Payroll Management",
                    "Accounting & Balance Sheet",
                    "AI-powered solutions",
                    "Real-time dashboard with sales, billing, and inventory reports",
                    "Advanced Reporting and Analytics",
                    "Free SSL and Custom domain",
                    "Use on any device: Phone, Tablet, or PC",
                  ]}
                />
              </div>
            </div>

            {/* ERP Modules Section */}
            <section className="container my-5">
              <h5 className="text-dark mb-4">
                Explore Integrated ERP Modules That Power Your Business
              </h5>
              <Row className="g-3">
                {[
                  RawMaterialsModule,
                  SuppliersModule,
                  PurchasesModule,
                  ProductionModule,
                  InventoryModule,
                  MarketingModule,
                  DigitalCatalogModule,
                  LeadsManagementModule,
                  QuoteManagementModule,
                  SalesOrderModule,
                  RetailPosModule,
                  ECommerceB2CModule,
                  ECommerceB2BModule,
                  OrdersManagementModule,
                  PackagingManagementModule,
                  DeliveryManagementModule,
                  CrmModule,
                  CouponsManagementModule,
                  AccountingModule,
                  HrmModule,
                  ProjectsModule,
                  ReportsModule,
                ].map((Module, index) => (
                  <Col md={6} lg={6} key={index}>
                    <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                      <Module />
                    </div>
                  </Col>
                ))}
              </Row>
            </section>
          </div>
        </section>
      </>
    );
  }
}

// Reusable FeatureSection component
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h5 className="fw-semibold">{title}</h5>

    <ul className="mb-0 ps-3">
      <Row>
        {items.map((item, idx) => (
          <Col xs={6} key={idx}>
            <li key={idx} className="mb-2">
              {item}
            </li>
            {/* <li key={idx}>{item}</li> */}
          </Col>
        ))}
      </Row>
    </ul>
  </div>
);
